import React from "react";
import { Header, Button } from "@dishopsaas/design-system";
import { useTheme, Box } from "@mui/material";
import { InfoBarHookReturn } from "../../../1_types/InfoBarTypes";
import { getAddress, getTodayOpeningStatus } from "../InfoBar.services";
import { getOrderTypeLabel } from "../../../utils";
import { ORDER_TYPE_CLICK_AND_SEAT, ORDER_TYPE_ICONS } from "../../../constants/order";
import {
  infoBarDesktopStyles,
  detailsStyle,
  userDropdownRoot,
} from "../InfoBar.styles";
import { CartBadge } from "./CartBadge";
import { OrderTypeActions } from "./OrderTypeActions";
import { UserDropdown } from "./UserDropdown/UserDropdown.view";
import { PRIMARY } from "../../../constants";
import ShopHeaderContent from "./ShopHeaderContent";
import { useResponsiveMaterial } from "../../../hooks/useResponsive";
import { useAppSelector } from "../../../redux/hook";
import { isQrCode } from '../../../utils'
export const InfoBarDesktop: React.FC<InfoBarHookReturn> = ({
  userConnected,
  user,
  orderType = ORDER_TYPE_CLICK_AND_SEAT,
  nbCommande,
  handlers,
  logoUrl,
  name,
  openHours,
  points,
  isClosedShop
}) => {
  const theme = useTheme();
  const styles = infoBarDesktopStyles(theme);
  const { text, isOpen } = getTodayOpeningStatus(openHours, isClosedShop);
  const orderTypeLabel = getOrderTypeLabel(orderType);
  const orderTypeIcon = ORDER_TYPE_ICONS[orderType];
  const isTablet = useResponsiveMaterial("md", "up");
  const showTextsLg = useResponsiveMaterial("lg", "up");
  const { pendingOrderReducer, configurationReducer, shopReducer } = useAppSelector((s) => s);
  const { address } = pendingOrderReducer;
  const { theme: themeConfiguration, google, secondaryColor, orderTypes } = configurationReducer;
  const { addressShop, shopName } = shopReducer;
  return (
    <Header
      leftElement={
        showTextsLg && (
          <ShopHeaderContent
            logoUrl={logoUrl}
            name={name}
            text={text}
            isOpen={isOpen}
            showTextsLg={showTextsLg}
            styles={styles}
            address={address}
            addressShop={addressShop}
            orderType={orderType}
            theme={themeConfiguration}
            googleApiKey={google.apiKey}
            secondaryColor={secondaryColor}
            orderTypes={orderTypes}
            openHours={openHours}
            shopName={shopName}
            isQrCode={isQrCode()}
          />
        )
      }
      centerElement={
        <OrderTypeActions
          orderTypeLabel={orderTypeLabel}
          orderTypeIcon={orderTypeIcon}
          addressLabel={getAddress()}
          onClick={handlers.openAddress}
        />
      }
      rightElement={
        userConnected ? (
          <UserDropdown
            user={user}
            points={points}
            showDetails={isTablet}
            nbCommande={nbCommande}
            styles={styles}
            handlers={handlers}
            width={"340px"}
          />
        ) : (
          <Box
            sx={{
              ...userDropdownRoot,
              gap: '18px',
            }}
          >
            <CartBadge count={nbCommande} onClick={handlers.handleCartClick} />
            {!isQrCode() && (
              <Button
                label="Se connecter"
                colorType={PRIMARY}
                size="medium"
                onClick={handlers.handleOpenLogin}
              />
            )}
          </Box>
        )
      }
      containerStyle={styles.headerStyle}
      detailStyle={{
        ...detailsStyle(theme),
        rightStyle: {
          ...detailsStyle(theme).rightStyle,
          ...(userConnected && {
            gap: 0,
          }),
        },
      }}
    />
  );
};
